import { Card, CardBody } from 'reactstrap'
import { trackWebEngageEvent, params as webengage_params } from '../../utils/customWebengageEvents'
import { useMediaQuery } from 'react-responsive'

const Byjus_Advantage = ({ profileData, isResultPage }) => {
    const isSmallDevice = useMediaQuery({ query: '(max-width: 767px)' })
    let date = new Date();
    const videoObject = {
        heading: {
            banner_heading: "Aakash Advantage",
        },
        SOE: {
            banner_video_url: 'https://www.youtube.com/watch?v=fnuhvsXKRGc',
        },
        SOF: {
            banner_video_url: 'https://www.youtube.com/watch?v=29zfZ3tdR4c',
        },
        SOM: {
            banner_video_url: 'https://www.youtube.com/watch?v=YrcE33eufPw',
        },
        AKTHE: {
            SOE: {
                banner_video_url: 'https://www.youtube.com/watch?v=fnuhvsXKRGc',
            },
            SOF: {
                banner_video_url: 'https://www.youtube.com/watch?v=29zfZ3tdR4c',
            },
            SOM: {
                banner_video_url: 'https://www.youtube.com/watch?v=YrcE33eufPw',
            },
        },
    }

    window.setInterval(trackClick, 100)
    function trackClick() {
        if (document.activeElement === (document.querySelector('#anthe-video') || document.querySelector('#Akthe-video'))) {
        const examType = profileData?.exam_type || 'ANTHE';
            const eventName =
                examType === 'AKTHE'
                    ? 'AKTHE_db_video'
                    : 'ANTHE_db_video_click';

            trackWebEngageEvent(eventName, webengage_params);
            window.focus();
        }
    }

    return (
        <>  
        {profileData?.exam_type === 'ANTHE' || profileData?.exam_type === 'AKTHE' ? (
                isResultPage ? (
                    <div>
                        <h3 className='text-dark-blue-60 mt-0 d-block d-lg-none'>Aakash Advantage</h3>
                        <Card className="border-0 ">
                            <CardBody className="p-3">
                                <div className='d-flex justify-content-between'>
                                    <div className='bg-white p-3 ps-5 align-content-center col-lg-7 d-none d-lg-block pe-lg-1'>
                                        <h3 className='text-aqua-10 font-size-lg'>Aakash ADVANTAGE: Unlocking Excellence in Education</h3>
                                        <p className='text-dark-grey fw-700'>Watch the video to know more about Aakash advantage</p>
                                    </div>
                                    <div className='col-lg-4 col-12 pe-lg-3 pt-1'>
                                        {videoObject[profileData.stream] &&
                                            videoObject[profileData.stream]?.banner_video_url ? (
                                            <iframe
                                                title="ANTHE banner video"
                                                width="100%"
                                                height="242px"
                                                src={(videoObject[
                                                    profileData.stream
                                                ]?.banner_video_url).replace('watch?v=', 'embed/')}
                                                id="anthe-video"
                                                className='rounded'
                                            ></iframe>
                                        ) : (
                                            <iframe
                                                title="ANTHE banner video"
                                                width="100%"
                                                height="232px"
                                                src={(videoObject['SOE']?.banner_video_url).replace(
                                                    'watch?v=',
                                                    'embed/',
                                                )}
                                                id="anthe-video"
                                            ></iframe>
                                        )}
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                ):(
                    <Card
                        className="border-0"
                        style={{
                            width: '100%',
                            height: '100%',
                            filter: 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))',
                        }}
                    >
                        <CardBody className="p-3 pb-1">
                            <div>
                                <h3 className="font-size-lg text-grey-black">
                                    {videoObject?.heading?.banner_heading}
                                </h3>
                            </div>
                            {videoObject[profileData.stream] &&
                                videoObject[profileData.stream]?.banner_video_url ? (
                                <iframe
                                    title="ANTHE banner video"
                                    width="100%"
                                    height="242px"
                                    src={(videoObject[
                                        profileData.stream
                                    ]?.banner_video_url).replace('watch?v=', 'embed/')}
                                    id="anthe-video"
                                ></iframe>
                            ) : (
                                <iframe
                                    title="ANTHE banner video"
                                    width="100%"
                                    height="232px"
                                    src={(videoObject['SOE']?.banner_video_url).replace(
                                        'watch?v=',
                                        'embed/',
                                    )}
                                    id="anthe-video"
                                ></iframe>
                            )}
                        </CardBody>
                    </Card>
            )
            ) : profileData?.exam_type === 'AKTHE' ? (
                <Card
                    className="border-0"
                    style={{
                        width: '100%',
                        height: '100%',
                        filter: isSmallDevice
                            ? 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))'
                            : '',
                    }}
                >
                    <CardBody className="p-3">
                        <div className="d-none d-md-block">
                            <h3 className="font-size-lg text-grey-black">
                                {videoObject?.heading?.banner_heading}
                            </h3>
                        </div>
                        {profileData?.exam_type === 'AKTHE' &&
                            videoObject?.AKTHE?.[profileData.stream]
                                ?.banner_video_url && (
                                <iframe
                                    title="IAT banner video"
                                    width="100%"
                                    height="242px"
                                    src={
                                        videoObject.AKTHE[profileData.stream]
                                            .banner_video_url
                                    }
                                    id="Akthe-video"
                                ></iframe>
                            )}
                    </CardBody>
                </Card>
            ) : null}
        </>
    )
}
export default Byjus_Advantage
